<template>
    <div>
        <br>
        <h3>Trainee Information</h3>
        <hr>
        <vue-form :state="formstate">
            <div class="row">
                <div class="col">
                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.medicalSpeciality)">
                        <label>Medical Speciality</label>
                        <input type="text" name="medicalSpeciality" class="form-control" required
                               v-model.lazy="state.registrantData.traineeExtraData.medicalSpecialty" tabindex="15">
                        <field-messages name="medicalSpecialty" show="$touched || $submitted" class="form-control-feedback">
                            <div>Success!</div>
                            <div slot="required">This is a required field</div>
                        </field-messages>
                    </validate>
                    <validate auto-label class="form-group required-field"
                              :class="fieldClassName(formstate.traineeStatus)">
                        <label>What is your current trainee status?</label>

                        <select class="form-control" name="traineeStatus" required
                                v-model.lazy="state.registrantData.traineeExtraData.traineeType">
                            <option value="Student">Student</option>
                            <option value="Fellow">Fellow</option>
                            <option value="Resident">Resident</option>
                        </select>

                        <field-messages name="traineeStatus" show="$touched || $dirty || $submitted"
                                        class="form-control-feedback">
                            <div>Success!</div>
                            <div slot="required">This is a required field</div>
                        </field-messages>
                    </validate>
                </div>
            </div>
            <br>
            <h3>Proof of Training Status*</h3>
            <hr>
            <div class="row">
                <div class="col">
                    <label class="custom-file">
                        <input type="file" id="file" class="custom-file-input" @change="onFileSelected" tabindex="16">
                        <span class="custom-file-control">{{state.registrantData.proof.name}}</span>
                    </label>
                </div>
            </div>
        </vue-form>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'Trainees',
        data: function () {
            return {
                formstate: {},
            }
        },
        computed: {
            ...mapGetters({
                state: 'getState',
            }),

        },
        watch: {
            formstate: function (val) {
                this.state.formstate.trainee = val;
            },
        },
        methods: {
            onFileSelected: function (event) {
                this.$store.commit('addProof', event.target.files[0]);
            },
            fieldClassName: function (field) {

                if (!field) {
                    return ''
                }
                if ((field.$touched || field.$submitted) && field.$valid) {
                    return 'has-success'
                }
                if ((field.$touched || field.$submitted) && field.$invalid) {
                    return 'has-danger'
                }
            },
            onSubmit: function () {
                console.log(this.formstate.$valid)
            }
        },
    }
</script>

<style scoped>
.required-field > label::after {
  content: '*';
  color: red;
  margin-left: 0.25rem;
}
h3 {
  margin: 0 0 14px;
  padding: 18px 22px;
  background: linear-gradient(110deg, #148f94 0%, #427f9e 50%, #656dac 100%);
  border-radius: 12px;
  color: #ffffff;
  font-family: inherit;

  font-weight: 300;
  line-height: 1.35;
  letter-spacing: 0.025em;
  text-transform: uppercase;
}
hr {
  height: 1px;
  margin: 14px 0 20px;
  border: 0;
  background: linear-gradient(to right, #80c9c5, #d9deef);
}
/* Form sections and field panels */
.row {
  box-sizing: border-box;
  display: grid;
  grid-template-columns: minmax(0, 1fr);

  margin: 0;
  padding: 22px;
  background: linear-gradient(135deg, #eaf6f3 0%, #edf0fa 100%);
  border: 1px solid #d5e1ea;
  border-radius: 16px;
  box-shadow: 0 6px 20px rgba(49, 75, 111, 0.08);
}
.row > .col {
  box-sizing: border-box;
  width: auto;
  min-width: 0;
  max-width: none;
  padding: 20px;
  background: #ffffff;
  border: 1px solid #dfe6ee;
  border-radius: 11px;
}
.form-group {
  display: block;
  margin-bottom: 22px;
}
.form-group:last-child {
  margin-bottom: 0;
}
label {
  display: block;
  margin-bottom: 8px;
  color: #535c98;
  font-family: inherit;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.5;
}
.form-control {
  box-sizing: border-box;
  display: block;
  width: 100%;
  min-width: 0;
  height: auto;
  min-height: 48px;
  padding: 12px 14px;
  background: #fbfcfe;
  border: 1px solid #bdcddb;
  border-radius: 9px;
  box-shadow: inset 0 1px 3px rgba(49, 75, 111, 0.04);
  color: #535c98;
  font-family: inherit;

  font-weight: 400;
  line-height: 1.5;
  transition: background-color 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;
}
.form-control::placeholder {
  color: #7b8799;
  opacity: 1;
}
.form-control:hover {
  border-color: #8faebf;
}
.form-control:focus {
  outline: none;
  background: #ffffff;
  border-color: #168b91;
  box-shadow: 0 0 0 3px rgba(22, 139, 145, 0.15);
}
select.form-control {
  cursor: pointer;
}
/* File upload */
label.custom-file {
  box-sizing: border-box;
  display: block;
  position: relative;
  width: 100%;
  height: auto;
  margin: 0;
  padding: 18px;
  background: linear-gradient(135deg, #edf8f6 0%, #f0f1fa 100%);
  border: 2px dashed #bdcddb;
  border-radius: 10px;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}
label.custom-file:hover {
  border-color: #168b91;
}
label.custom-file:focus-within {
  border-color: #168b91;
  box-shadow: 0 0 0 3px rgba(22, 139, 145, 0.15);
}
.custom-file-input {
  box-sizing: border-box;
  display: block;
  position: static;
  width: 100%;
  max-width: 100%;
  height: auto;
  margin: 0;
  padding: 0;
  opacity: 1;
  z-index: auto;
  background: transparent;
  border: 0;
  color: #535c98;
  font: inherit;
  font-weight: 400;
  cursor: pointer;
}
.custom-file-input::file-selector-button {
  margin-right: 12px;
  padding: 10px 16px;
  background: linear-gradient(110deg, #167b83 0%, #5866a3 100%);
  border: 0;
  border-radius: 7px;
  color: #ffffff;
  font: inherit;
  font-weight: 600;
  cursor: pointer;
}
.custom-file-input::file-selector-button:hover {
  filter: brightness(0.92);
}
.custom-file-control {
  display: block;
  position: static;
  height: auto;
  margin-top: 12px;
  padding: 0;
  background: transparent;
  border: 0;
  box-shadow: none;
  color: #535c98;
  font-weight: 400;
  line-height: 1.5;
  overflow-wrap: anywhere;
}
.custom-file-control::before, .custom-file-control::after {
  display: none;
  content: none;
}
.custom-file-control:empty {
  display: none;
}
.form-control-feedback {
  margin-top: 7px;
  color: #535c98;
  line-height: 1.5;
}
.has-success .form-control {
  border-color: #459b83;
  background: #f5fbf8;
}
.has-success .form-control:focus {
  box-shadow: 0 0 0 3px rgba(69, 155, 131, 0.15);
}
.has-success .form-control-feedback {
  color: #28765f;
}
.has-danger .form-control {
  border-color: #c9606c;
  background: #fff8f9;
}
.has-danger .form-control:focus {
  box-shadow: 0 0 0 3px rgba(201, 96, 108, 0.15);
}
.has-danger .form-control-feedback {
  color: #ad3e50;
}
@media (max-width: 767px) {
  .row {
    padding: 14px;
    border-radius: 13px;
  }
  .row > .col {
    padding: 17px;
  }
  h3 {
    padding: 16px 18px;

  }
  label {
    font-size: 16px;
    font-weight: 500;
  }

  label.custom-file {
    padding: 14px;
  }
}
@media (max-width: 480px) {
  .row {
    padding: 10px;
  }
  .row > .col {
    padding: 14px;
  }
  h3 {
    padding: 14px 16px;
  }
  label {
    font-size: 15px;
    font-weight: 500;
  }
  label.custom-file {
    padding: 12px;
  } .custom-file-input::file-selector-button {
      margin-right: 8px;
      padding: 9px 12px;
    }
}
</style>
